function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "x01.03.-Studenta-port\\u0101ls---Pieejams-teorijas-eks\\u0101mens---Izv\\u0113l\\u0113ties-dienu-un-laiku---Forma",
  transform: "translate(-403.000000, -105.000000)",
  fill: "#079DC1",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(383.000000, 83.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Content",
  transform: "translate(20.000000, 16.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(0.000000, 6.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16,1 C16.5128358,1 16.9355072,1.38604019 16.9932723,1.88337887 L17,2 L17,3 L19,3 C20.5976809,3 21.9036609,4.24891996 21.9949073,5.82372721 L22,6 L22,20 C22,21.5976809 20.75108,22.9036609 19.1762728,22.9949073 L19,23 L5,23 C3.40231912,23 2.09633912,21.75108 2.00509269,20.1762728 L2,20 L2,6 C2,4.40231912 3.24891996,3.09633912 4.82372721,3.00509269 L5,3 L7,3 L7,2 C7,1.44771525 7.44771525,1 8,1 C8.51283584,1 8.93550716,1.38604019 8.99327227,1.88337887 L9,2 L9,3 L15,3 L15,2 C15,1.44771525 15.4477153,1 16,1 Z M20,11 L4,11 L4,20 C4,20.5128358 4.38604019,20.9355072 4.88337887,20.9932723 L5,21 L19,21 C19.5128358,21 19.9355072,20.6139598 19.9932723,20.1166211 L20,20 L20,11 Z M7,5 L5,5 C4.48716416,5 4.06449284,5.38604019 4.00672773,5.88337887 L4,6 L4,9 L20,9 L20,6 C20,5.48716416 19.6139598,5.06449284 19.1166211,5.00672773 L19,5 L17,5 L17,6 C17,6.55228475 16.5522847,7 16,7 C15.4871642,7 15.0644928,6.61395981 15.0067277,6.11662113 L15,6 L15,5 L9,5 L9,6 C9,6.55228475 8.55228475,7 8,7 C7.48716416,7 7.06449284,6.61395981 7.00672773,6.11662113 L7,6 L7,5 Z",
  id: "icon"
}))))));

function SvgIcCalendarBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B31FD7CC-4123-4C87-9AD6-0C31396A3020") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendarBlue);
export default __webpack_public_path__ + "static/media/ic-calendar-blue.b6596f1b.svg";
export { ForwardRef as ReactComponent };